var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0984 7.1195C10.0984 8.88063 8.64097 10.3489 6.79272 10.3489C4.94447 10.3489 3.48706 8.88063 3.48706 7.1195C3.48706 5.35838 4.94447 3.89014 6.79272 3.89014C8.64097 3.89014 10.0984 5.35838 10.0984 7.1195ZM9.60734 10.9373C8.81703 11.5026 7.84444 11.8359 6.79272 11.8359C4.14577 11.8359 2 9.72431 2 7.1195C2 4.51469 4.14577 2.40308 6.79272 2.40308C9.43966 2.40308 11.5854 4.51469 11.5854 7.1195C11.5854 8.1561 11.2456 9.1146 10.6696 9.89299L14.2279 13.1078C14.5326 13.3831 14.5564 13.8533 14.2811 14.158C14.0058 14.4627 13.5357 14.4865 13.231 14.2112L9.60734 10.9373Z",
    fill: "#0F9EE0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPurple);
export default __webpack_public_path__ + "static/media/search_purple.3d8e99ead5aff2392e8a7366388d8859.svg";
export { ForwardRef as ReactComponent };